const PEN_EDIT_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
<g clip-path="url(#clip0_3283_7940)">
<path d="M2.39668 15.2779C2.43497 14.9334 2.45411 14.7611 2.50624 14.6C2.55249 14.4572 2.61784 14.3212 2.70051 14.1958C2.79369 14.0545 2.91627 13.9319 3.16142 13.6868L14.1667 2.68157C15.0871 1.76109 16.5795 1.76109 17.5 2.68157C18.4205 3.60204 18.4205 5.09443 17.5 6.0149L6.49475 17.0201C6.2496 17.2653 6.12702 17.3879 5.98572 17.481C5.86035 17.5637 5.72439 17.6291 5.58152 17.6753C5.42048 17.7274 5.24819 17.7466 4.90362 17.7849L2.08331 18.0982L2.39668 15.2779Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</g>
<defs>
<clipPath id="clip0_3283_7940">
<rect width="20" height="20" fill="white" transform="translate(0 0.181641)"/>
</clipPath>
</defs>
</svg>`;

export default PEN_EDIT_ICON;
